/** @jsx jsx */
import { jsx } from "theme-ui";
import Container from "../container";
import ImageHeadingTextColumnItem from "./imageHeadingTextColumnItem";
import LinkResolve from "./linkResolve";
import "../../scss/component/threeCard.scss";

const ThreeCard = ({ value }) => {
  return (
    <div
      id={value?.id?.current ? value?.id?.current : ""}
      sx={{
        background: value?.background == "white" ? "white" : "grayBG",
        paddingTop: "75px",
        paddingBottom: "75px",
      }}
    >
      <Container>
        {value.headline && (
          <h2
            sx={{
              fontSize: "3rem",
              marginBottom: "0",
              marginTop: "0",
              width: "100%",
              textAlign: "center",
            }}
          >
            {value.headline}
          </h2>
        )}
        {value.subhead && (
          <h3
            sx={{
              fontSize: "1.5rem",
              marginTop: "10px",
              marginBottom: "0",
              width: "100%",
              textAlign: "center",
              color: "textGray",
              fontWeight: "300 !important",
              marginBottom:"0px",
            }}
          >
            {value.subhead}
          </h3>
        )}
        {value.items && (
          <ul
            className="three-card-list"
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "flex-start",
              boxSizing: "content-box",
              margin: "0px",
              paddingLeft: "0px",
              alignItems:"stretch",
              marginTop:"40px",
            }}
          >
            {value.items.map((item, index) => (
              <li
                className="three-card-list-item"
                sx={{
                  listStyle: "none",
                  textAlign: "center",
                  maxWidth:["400px", "100%", "100%"],
                  background: value?.background == "white" ? "grayBG" : "white",
                  padding:"48px 48px 47px 48px",
                  boxSizing: "border-box",
                  borderRadius: "8px",
                  "&:last-child": {
                    marginBottom: ["0px", "0px", "0px"],
                  },
                  ".text-image-image":{
                    marginBottom:"24px",
                  },
                  h3:{
                    fontSize: "1.5rem",
                    marginBottom: "5px",
                    marginTop:"0px",
                    fontWeight:"600",
                  }
                }}
                key={index}
              >
                <ImageHeadingTextColumnItem value={item} parent={value} />
              </li>
            ))}
          </ul>
        )}
        {value.link && (
          <div
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop:"40px",
              a: {
                variant: "buttons.primaryBlue",
                marginTop: "15px",
                display: "inline-block",
              },
            }}
          >
            <LinkResolve
              link={value.link.link}
              children={value.link.label}
              target="_blank"
              ariaLabel={value.link?.arialLabel}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

export default ThreeCard;
